// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cursur-pointer[data-v-056df889]{cursor:pointer}.nav__icon-frame[data-v-056df889]{width:44px;height:44px;border-radius:10.4px}.btn-notification[data-v-056df889]{background-color:#e5f9ed;text-decoration:none;position:relative;border-radius:12px;padding:5px 10px!important;cursor:pointer}.badge-notification[data-v-056df889]{background-color:#ff838f;position:absolute;top:-4px;right:-7px;padding:0 5px;margin:1px;border-radius:50%;color:#fff;font-size:10px}", ""]);
// Exports
module.exports = exports;
